import "./MyStandingsTable.css";
import "./Goleo.css";
import { hexToRgba } from "../Functions/Colors";

const Goleo = ({ goleos, themeColor }) => {
  return (
    <section
      className="table-container goleo-table"
      aria-labelledby="goleo-title"
      style={{
        "--theme-color": themeColor || "var(--accent)",
        "--theme-soft": hexToRgba(themeColor, 0.14),
      }}
    >
      <header className="table-head">
        <h2 className="block-title" id="goleo-title">
          Goleo
        </h2>
      </header>

      {goleos.men.length > 0 && (
        <GoleoTable title="Hombres" players={goleos.men} playerLabel="Jugador" />
      )}

      {goleos.women.length > 0 && (
        <GoleoTable title="Mujeres" players={goleos.women} playerLabel="Jugadora" />
      )}
    </section>
  );
};

const GoleoTable = ({ title, players, playerLabel }) => (
  <div className="goleo-group">
    <h3 className="goleo-subtitle">{title}</h3>
    <table className="scorers">
      <caption className="sr-only">Goleo {title.toLowerCase()}</caption>
      <thead>
        <tr>
          <th scope="col" className="col-pos">
            <abbr title="Posición">#</abbr>
          </th>
          <th scope="col" className="col-player">
            {playerLabel}
          </th>
          <th scope="col" className="col-team">
            Equipo
          </th>
          <th scope="col" className="col-goals">
            <abbr title="Goles">G</abbr>
          </th>
        </tr>
      </thead>
      <tbody>
        {players.map((player, index) => (
          <tr key={player.player_id} className={index === 0 ? "is-leader" : undefined}>
            <td className="col-pos">
              <span className="pos-badge">{index + 1}</span>
            </td>
            <th scope="row" className="col-player">
              <span className="scorer-name">{player.player_name}</span>
              <span className="scorer-team-inline">{player.team_name}</span>
            </th>
            <td className="col-team">{player.team_name}</td>
            <td className="col-goals">{player.goals}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default Goleo;
